import { buildRichtextHtmlMap } from 'features/EmailEditor/campaignEmailCustomizationHelpers'
import { getTemplate, resolveEditorTemplateKey } from 'features/EmailEditor/templates'
import {
  extractPreviewBodyHtml,
  extractSocialMediaUrls,
  generateSocialMediaLinksHtml,
  getHtmlFromMjml,
  normalizeEmailFooterFields,
  replaceTagsWithPreviewContent,
  resolveBrandFallbackColors,
  resolveSocialFooterTheme
} from 'features/EmailEditor/utils'

// logoUrl is deliberately excluded: a layout preview always shows the logo slot as
// a placeholder so the customer can see where their own logo goes.
const PREVIEW_HOTEL_IDENTITY_FIELDS = [
  'hotelName',
  'hotelAddress',
  'hotelCityStateZip',
  'hotelPhone',
  'hotelWebsite',
  'hotelWebsiteUrl',
  'socialMediaLinks'
]

const PREVIEW_BRAND_FALLBACK_COLOR = '#ffffff'

export function buildTemplatePreviewParams(emailState = {}, brandPrimaryColor = '') {
  const previewParams = { brandPrimaryColor }

  PREVIEW_HOTEL_IDENTITY_FIELDS.forEach(field => {
    if (emailState[field]) {
      previewParams[field] = emailState[field]
    }
  })

  return previewParams
}

export function buildShellTemplatePreviewHtml(templateKey, userName = 'Guest', previewParams = {}) {
  const resolvedKey = resolveEditorTemplateKey(templateKey)
  const currentTemplate = getTemplate(resolvedKey)
  const emailState = {
    ...currentTemplate.params,
    ...resolveBrandFallbackColors(
      currentTemplate.params,
      previewParams.brandPrimaryColor || PREVIEW_BRAND_FALLBACK_COLOR
    )
  }

  PREVIEW_HOTEL_IDENTITY_FIELDS.forEach(field => {
    if (previewParams[field]) {
      emailState[field] = previewParams[field]
    }
  })

  const socialUrls = extractSocialMediaUrls(emailState.socialMediaLinks)
  const templateVariables = normalizeEmailFooterFields({
    ...emailState,
    ...socialUrls
  })

  const socialTheme = resolveSocialFooterTheme(resolvedKey)

  const html = getHtmlFromMjml(currentTemplate.template, templateVariables, {
    ...buildRichtextHtmlMap(emailState.richtextFields || {}),
    socialMediaLinksHtml: generateSocialMediaLinksHtml(
      emailState.socialMediaLinks,
      socialTheme.theme,
      socialTheme.brandColor
    )
  }, { templateKey: resolvedKey })

  return replaceTagsWithPreviewContent(extractPreviewBodyHtml(html), userName)
}

export default buildShellTemplatePreviewHtml
